import React from 'react';
import { AddressSearch } from '../../components/Address/addressSearch/search';

export const AddressTable = () => {
  return <AddressSearch isOverlay={false} isSurroundingModalOpen={true} />;
};
